import { entra } from '../variables/identityUrl'

export const IDENTITY_CONFIG = {
    authority: entra ? process.env.REACT_APP_AUTH_URL_ENTRA : process.env.REACT_APP_AUTH_URL,
    client_id: entra ? process.env.REACT_APP_IDENTITY_CLIENT_ID_ENTRA : process.env.REACT_APP_IDENTITY_CLIENT_ID,
    redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_REDIRECT_URL,
    login: process.env.REACT_APP_AUTH_URL + "/login",
    automaticSilentRenew: true,
    loadUserInfo: entra ? false : true,
    silent_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_SILENT_REDIRECT_URL,
    post_logout_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_LOGOFF_REDIRECT_URL,
    response_type: "code",
    response_mode: "query",
    scope: entra ? "api://bb81418d-c6f9-4645-9137-8933930a60d5/access_as_user openid profile email offline_access" : "openid profile email AG_DatabaseAPI ASH_LicenseAPI ASH_IdentityAPI ashridge.profile",
    ...(entra && { code_challenge_method: "S256" })
};

export const METADATA_OIDC = entra
    ? undefined
    : {
        issuer: process.env.REACT_APP_AUTH_URL,
        jwks_uri: process.env.REACT_APP_AUTH_URL + "/.well-known/openid-configuration/jwks",
        authorization_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/authorize",
        token_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/token",
        userinfo_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/userinfo",
        end_session_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/endsession",
        check_session_iframe: process.env.REACT_APP_AUTH_URL + "/connect/checksession",
        revocation_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/revocation",
        introspection_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/introspect",
    };
